import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import ParametreService from "@/integrations/service/parametre.service";

export const useParametres = () => {
  return useQuery({
    queryKey: queryKeys.parametres,
    queryFn: ParametreService.getAll,
  });
};

export const useSetParametre = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cle, valeur }: { cle: string; valeur: string }) => ParametreService.set(cle, valeur),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.parametres });
    },
  });
};
